export function getOutcomeColor(outcome: string): string {
  switch (true) {
    case outcome === "W":
      return "#2cb94c";
    case outcome === "D":
      return "#34d98626";
    case outcome === "L":
      return "#eb1b24";
    default:
      return "#34d98626";
  }
}
